/* eslint-disable react/prop-types */
import classes from './index.module.css';

export default function CollectionPanel({ title, desc }) {
  return (
    <div className={classes.condition}>
      <div className={classes.condition_title}>
        {title}
      </div>
      <div>
        {desc}
      </div>
      <div>
      </div>
    </div>
  );
}
